/* global Plyr, Swiper */
import Plyr from 'plyr';
import Swiper from 'swiper';

'use strict';

const $ = window.jQuery;

export default function frontPage() {
    // Big title parallax
    $( window ).scroll( function() {
        let scroll = $( window ).scrollTop();

        $( '.home-welcome__title' ).css( { 'transform': `translateX(-${ scroll / 7 }px)` } );
        $( '.home-welcome__title span' ).css( { 'transform': `translateX(${ scroll / 4 }px)` } );
    } );

    // Video
    const homePlayer = new Plyr( '#homePlayer' );

    $( '#homeVideoOpen' ).on( 'click', function() {
        homePlayer.play();
    } );

    $( '#homeVideoClose' ).on( 'click', function() {
        homePlayer.pause();
    } );

    // Quotes
    const quotesSlider = new Swiper( '#quotesSlider', {
        loop: true,
        noSwiping: false,
        simulateTouch: true,
        grabCursor: true,
        navigation: {
            prevEl: '#quotesPrev',
            nextEl: '#quotesNext',
        },
        on: {
            slideChange: function( swiper ) {
                $( '.home-quotes__page' ).removeClass( 'is-active' );
                $( `#quotesPage${ swiper.realIndex }` ).addClass( 'is-active' );
            },
        },
    } );

    $( '.home-quotes__page' ).on( 'click', function() {
        const clickedIndex = $( this ).data( 'index' );

        quotesSlider.slideTo( clickedIndex );
    } );

    // Expertises
    const expertisesDescription = new Swiper( '#expertisesDescription', {
        noSwiping: true,
        simulateTouch: false,
        navigation: {
            prevEl: '#expertisesPrev',
            nextEl: '#expertisesNext',
        },
    } );

    const expertisesSlider = new Swiper( '#expertisesSlider', {
        noSwiping: true,
        simulateTouch: false,
        navigation: {
            prevEl: '#expertisesPrev',
            nextEl: '#expertisesNext',
        },
    } );

    $( '.expertise' ).on( 'click', function() {
        const clickedIndex = $( this ).data( 'index' );

        expertisesDescription.slideTo( clickedIndex );
        expertisesSlider.slideTo( clickedIndex );
    } );

    // Services
    const servicesSlider = new Swiper( '#servicesSlider', {
        speed: 1000,
        loop: true,
        parallax: true,
        grabCursor: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
    } );

    // Partners
    const partnersSlider = new Swiper( '#partnersSlider', {
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        grabCursor: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        breakpoints: {
            767: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
    } );
};
